import { render, staticRenderFns } from "./racksModal.vue?vue&type=template&id=71820fa4&scoped=true"
import script from "./racksModal.vue?vue&type=script&lang=js"
export * from "./racksModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71820fa4",
  null
  
)

export default component.exports